import type { ReactNode } from "react";

import classNames from "classnames/bind";

import styles from "./Carousel.module.scss";
import CarouselContainer from "./CarouselContainer";
import CarouselNavigation from "./CarouselNavigation";
import type { CarouselSwiperProps } from "./CarouselSwiper";
import CarouselSwiper from "./CarouselSwiper";

const cx = classNames.bind(styles);

export interface CarouselProps extends CarouselSwiperProps {
    id: string;
    title?: string;
    isCarouselSection?: boolean;
    navigationComponent?: ReactNode;
    navigationClassName?: string;
    navigationButtonClassName?: string;
    navigationTitleClassName?: string;
    carouselBodyClassName?: string;
}

const Carousel = ({
    children,
    id,
    title,
    className,
    navigationClassName,
    isCarouselSection,
    navigationComponent,
    navigationButtonClassName,
    navigationTitleClassName,
    carouselBodyClassName,
    ...carouselSwiperProps
}: CarouselProps) => {
    return (
        <CarouselContainer
            className={cx(
                "carousel",
                {
                    carousel__section: isCarouselSection,
                },
                className
            )}
        >
            {navigationComponent || (
                <CarouselNavigation
                    forId={id}
                    title={title}
                    className={cx("carousel__section__navigation", navigationClassName)}
                    navButtonClassName={navigationButtonClassName}
                    titleClassName={navigationTitleClassName}
                />
            )}
            <CarouselSwiper
                {...carouselSwiperProps}
                id={id}
                className={cx("carousel__section__swiper", carouselBodyClassName)}
            >
                {children}
            </CarouselSwiper>
        </CarouselContainer>
    );
};

export default Carousel;
